import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import procedimientos from "../../../../Core/procedimientos";
import "./FiltroPrecio.component.scss";

const FiltroPrecioComponent = ({ cambiarPrecio, Minimo = 0, Maximo = 0 }) => {
  const [minimoValue, setMinimoValue] = useState(0);
  const [maximoValue, setMaximoValue] = useState(Maximo);
  const [minimoFormat, setMinimoFormat] = useState("");
  const [maximoFormat, setMaximoFormat] = useState("");
  const { FormatearPrecio } = procedimientos.prototype;
  const margenMaximo = 100;

  const changeMinimo = (e) => {
    const minimoFormat = FormatearPrecio(e.target.value);
    setMinimoFormat(minimoFormat);
    setMinimoValue(e.target.value);
    cambiarPrecio(minimoValue, maximoValue);
  };

  const changeMaximo = (e) => {
    const maximoFormat = FormatearPrecio(e.target.value);
    setMaximoFormat(maximoFormat);
    setMaximoValue(e.target.value);
    cambiarPrecio(minimoValue, maximoValue);
  };

  useEffect(() => {
    const minimoFormat = FormatearPrecio(0);
    setMinimoFormat(minimoFormat);
  }, [Minimo]);

  useEffect(() => {
    const maximoFormat = FormatearPrecio(Maximo + margenMaximo);
    setMaximoFormat(maximoFormat);
    setMaximoValue(Maximo + margenMaximo);
  }, [Maximo]);

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6">
          <Form>
            <Form.Group>
              <Form.Label className="h6 form-control">
                {minimoFormat}
              </Form.Label>
              <Form.Control
                type="range"
                min="0"
                max={Minimo}
                step="1"
                value={minimoValue}
                onChange={changeMinimo}
              />
            </Form.Group>
          </Form>
        </div>
        <div className="col-12 col-lg-6">
          <Form>
            <Form.Group>
              <Form.Label className="h6 form-control">
                {maximoFormat}
              </Form.Label>
              <Form.Control
                type="range"
                min={Minimo}
                max={Maximo + margenMaximo}
                step="1"
                value={maximoValue}
                onChange={changeMaximo}
              />
            </Form.Group>
          </Form>
        </div>
      </div>
    </>
  );
};

export default FiltroPrecioComponent;
